import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { categories } from "../data";

export default function Products() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash]);

  return (
    <main data-testid="products-page" className="pb-12">
      <section className="border-b border-ink-700 section-padding pt-24 pb-16" data-testid="products-header">
        <p className="font-mono text-[11px] tracking-[0.24em] uppercase text-textmuted mb-4">
          / catalogue / master
        </p>
        <h1 className="h-display text-5xl md:text-7xl lg:text-[7rem] max-w-[16ch]">
          The full <span className="text-signal-amber">catalogue.</span>
        </h1>
        <p className="mt-6 font-mono text-sm text-textmuted max-w-2xl leading-relaxed">
          Categorised across three lines — Education, Industrial and Automation.
          Click any item to view all models with specs and images.
        </p>
      </section>

      {categories.map((cat) => (
        <section
          id={cat.slug}
          key={cat.slug}
          className="section-padding py-20 border-b border-ink-700"
          data-testid={`products-section-${cat.slug}`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-10">
            <div className="lg:col-span-4">
              <p className="overline mb-3">{cat.code} · LINE</p>
              <h2 className="h-display text-4xl md:text-5xl mb-4">{cat.title}</h2>
              <p className="font-mono text-sm text-textmuted leading-relaxed">{cat.description}</p>
              <Link to="/enquiry" className="btn-ghost mt-6" data-testid={`enquiry-${cat.slug}`}>
                Enquire <ArrowUpRight size={14} />
              </Link>
            </div>
            <div className="lg:col-span-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 grid-cells">
                {cat.products.map((p, idx) => (
                  <Link
                    key={p.slug}
                    to={`/products/${p.slug}`}
                    className="p-5 flex items-center justify-between gap-4 hover-lift group"
                    data-testid={`product-row-${cat.slug}-${idx}`}
                  >
                    <div>
                      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-signal-amber mb-1">
                        {cat.code}.{String(idx + 1).padStart(2, "0")} · {p.count} model{p.count === 1 ? "" : "s"}
                      </p>
                      <p className="font-display font-bold text-base leading-tight group-hover:text-signal-amber transition-colors">
                        {p.name}
                      </p>
                      <p className="font-mono text-[10px] uppercase tracking-[0.18em] text-textmuted mt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                        View models →
                      </p>
                    </div>
                    <ArrowUpRight size={16} className="text-textmuted group-hover:text-signal-amber transition-colors flex-shrink-0" />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}
    </main>
  );
}
